import styled from 'styled-components'
import styledMUI from '@emotion/styled'
import CircularProgressWithLabel from '@mui/material/CircularProgress'
import Label from './Label'
import { ArrowCircle, ArrowCircleRight } from '../../assets/icons/arrow'
import {getScaleValue} from "../personalizedHealthEvaluation/PersonalizedHealthEvaluation";

const GradientRing = styled.div<{
  size: number
  thickness: number
  gradient: string
}>`
  position: absolute;
  width: ${({ size }) => size + 'px'};
  height: ${({ size }) => size + 'px'};
  border-radius: 50%;
  top: 0;
  left: 0;
  background: ${({ gradient }) => gradient};
  filter: blur(10px);
  transform: translate3d(0, 0, 0);
  mask: radial-gradient(
    farthest-side,
    black calc(50% - ${({ thickness }) => Math.max(thickness - 1, 0)}px)
  );
  -webkit-mask: radial-gradient(
    farthest-side,
    black calc(50% - ${({ thickness }) => Math.max(thickness - 1, 0)}px)
  );
  pointer-events: none;
`

const GradientOverlay = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 100%
  );
  pointer-events: none;

  @media print {
    display: none !important;
  }
`

export const Background = styled.div<{
  bgColor: string
  hasBackground: boolean
  woBorder?: boolean
  border: string
}>`
  margin: 0px auto;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  vertical-align: top;
  margin: 0 auto;
  
  padding: 15px 20px 20px 20px;

  border-radius: 10px;
  background: ${({ woBorder }) => woBorder ? 'transparent' : `white`};
  border: ${({ woBorder }) => woBorder ? '' : `1.5px solid #ededed`};

  &:hover:before {
    opacity: 1;
    background: ${({woBorder, bgColor}) => woBorder ? 'transparent' : `radial-gradient(circle at 50% 70%, transparent 0, transparent 40%, ${bgColor} 100%);`};
  }
  &:before {
    border-radius: 10px;
    overflow: hidden;
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: transparent;
    cursor: poitner;
    z-index: 1;
    opacity: 1;
    transition: all .4s ease;
  } 
  &:after {
    border-radius: 10px;
    overflow: hidden;
    content: ' ';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60%;
    background: blue;
    cursor: poitner;
    z-index: 10;
    opacity: 1;
    background: ${({woBorder}) => woBorder ? 'transparent' : `radial-gradient(circle at 50% 130%, white 0, transparent 70%, transparent 100%);`};

  }
  
  @media print {
    &:hover:before, &:before, &:after {
      background: transparent!important;
    }
  }



`
export const BackgroundCircle = styled(CircularProgressWithLabel)`
  position: absolute;

  top: -35px;
  left: -35px;

  border-radius: 50%;
`

export const Name = styled.div`
  text-align: center;
  width: 100%;
  font-size: 24px;
  text-decoration: none;
  margin-bottom: 20px;

  color: var(--text-main, #1a1a1a);
  text-align: center;
  /* Header/S */
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.32px;
`
export const Value = styled.div<{
  size: number
  fullSize: number
  color: string
  bgColor: string
}>`
  position: absolute;

  width: 135px;
  height: 135px;
  
  @media print {
    background: #fff;
  }

  border-radius: 50%;

  color: ${({ color }) => color};

  text-align: center;
  font-size: 40px;
  font-weight: bold;
  vertical-align: middle;
  border-radius: 50%;
  display: flex;
  align-items: center; /* vertical alignment */
  justify-content: center;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  background: #fff;

  span {
    /* margin-top: 10px; */
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  svg {
    position: absolute;
  }
  p {
    margin: 0px;
  }
  .MuiCircularProgress-root {
    opacity: 0.25;
  }
`

const CircleProgress   = styledMUI(CircularProgressWithLabel)(
  ({ isMax }: { isMax: boolean }) => ({
    boxShadow: isMax ? 'inset 0px 0px 5px 10px #fff' : 'initial',
    borderRadius: '50%'
  })
)

const ArrowProgress = styled.div<{
  arrowColor?: string
  rotate?: number
}>`
  height: calc(40% - 0px) !important;
  width: 100%;
  border-radius: 50%;
  position: absolute;

  rotate: ${({ rotate = 0 }) => rotate + 'deg'};


  svg {
    rotate: -18deg;
    left: -8px;
    position: absolute;
    path {
      fill: ${({ arrowColor }) => arrowColor || 'lightgrey'};
    }
  }
`

const Percentage = (props: any) => {
  let item = props || {}
  let { startDeg = 0, overflowK = 1, endDeg = 360, link, woTitle } = props
  let { value, name, R, A, G, GREY, isLabel } = item
  let size = 200
  let width = 7

  if (endDeg < startDeg) {
    endDeg = endDeg + 360
  }
  let deltaDeg = endDeg - startDeg
  const colors: any = {
    R: '#E96863',
    A: '#FFC107',
    GL: '#7BDCB5',
    G: '#3BAAB0',
    GREY: '#bdbdbd',
  }
  const bgColors: any = {
    R: '#e9686333',
    A: '#ffc1072c',
    GL: '#7bdcb533',
    G: '#3baab02e',
    GREY: '#818181',
  }

  const scaleSegments = [
    { key: 'G', perc: 3, gradientFrom: '#218B8F', gradientTo: '#C2EAED' },
    { key: 'GL', perc: 8, gradientFrom: '#93DAB8', gradientTo: '#F3FFF9' },
    { key: 'A', perc: 20, gradientFrom: '#FFECB3', gradientTo: '#FF9000' },
    { key: 'R', perc: 69, gradientFrom: '#F8D1CC', gradientTo: '#D83F3D' },
  ]

  const isValueMissing =
    props?.total?.value === undefined || props?.total?.value === null

  let _endDeg = 0
  const arr = scaleSegments.map((segment) => {
    const deg = getDeg(segment.perc)
    const segmentColor = isValueMissing ? colors.GREY : colors[segment.key]
    const itemData = {
      ...segment,
        deg,
      color: segmentColor,
      startDeg: _endDeg,
      endDeg: _endDeg + deg,
    }
    _endDeg += deg
    return itemData
  })

  function getDeg(perc: number) {
    return deltaDeg * (perc / 100)
  }
  // let startDeg = max.startDeg;

  const scaleKey = isValueMissing ? 'GREY' : getScaleValue(props?.total)
  const _value = scaleKey
  const max = {
    key: scaleKey,
    color: colors[scaleKey] || colors.GREY,
    bgColor: bgColors[scaleKey] || bgColors.GREY,
  }

  let k = deltaDeg / 360
  let opts = isLabel ? {'data-shadow': true} : {}

  let selectedValueItem = arr.find((segment) => segment.key === scaleKey) || arr[arr.length - 1]
  let bcg_rotate = selectedValueItem.startDeg || 0
  let bcg_value = k * selectedValueItem.perc
  let dd = selectedValueItem.startDeg + (selectedValueItem.endDeg - selectedValueItem.startDeg ) /2;// * ((d2 || 1) / ((d2 + d1) || 1));
  let el_perc = 75 + dd;

  const gradientStops = (() => {
    if (isValueMissing) {
      return '#bdbdbd 0deg, #bdbdbd 360deg'
    }
    let currentDeg = 0
    const stops: string[] = []
    scaleSegments.forEach(({ perc, gradientFrom, gradientTo }) => {
      const segDeg = getDeg(perc)
      const startPoint = currentDeg
      const endPoint = currentDeg + segDeg
      stops.push(`${gradientFrom} ${startPoint}deg`, `${gradientTo} ${endPoint}deg`)
      currentDeg = endPoint
    })
    if (currentDeg < deltaDeg) {
      stops.push(`transparent ${currentDeg}deg`, `transparent ${deltaDeg}deg`)
    }
    if (deltaDeg < 360) {
      stops.push(`transparent ${deltaDeg}deg`, `transparent 360deg`)
    }
    return stops.join(', ')
  })()

  const gradientBackground = `conic-gradient(from ${startDeg}deg, ${gradientStops})`

  // el_perc = bcg_value//3.14//(selectedValueItem.startDeg + selectedValueItem.endDeg ) / 2
  console.log("qqqqq rotate", props);
  return (
    <Background
      {...opts}
      woBorder={props.woBorder}
      hasBackground={props?.hasBackground}
      bgColor={bgColors[_value] || max.bgColor}
      border={isLabel && name ? 'true' : 'false'}
    >
      {isLabel && <Label color={max.key}  />}
      {!woTitle && name && (
        <Name style={{marginTop: '5px'}}>
          {name.slice(0, 20)}
          {name.slice(20).length > 0 && ' ...'}
        </Name>
      )}
      <div
        style={{
          position: 'relative',
          width: size + 'px',
          height: (overflowK || 1) * size + 'px',
          margin: '0 auto',
          overflow: 'hidden',
        }}
        data-animch={'6'}
      >
        <GradientRing
          size={size}
          thickness={width}
          gradient={gradientBackground}
        />
        <Value
          size={size * 0.65}
          fullSize={size}
          bgColor={isValueMissing ? bgColors.GREY : max.bgColor}
          color={isValueMissing ? colors.GREY : max.color}
          style={{ position: 'absolute' }}
          // style={{ rotate: '90deg' }}
        >
          <div>
            <div style={{
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex',
              position: 'relative'
            }}>
              <p
                style={{
                  fontSize: '68px',
                  fontWeight: 400,
                  letterSpacing: '-4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '135px',
                  height: '135px',
                  borderRadius: '100%',
                }}
              >{props?.total?.value ?? '-'}</p>
              <GradientOverlay />

            {link && (
              <div style={{zIndex: 100}}>
                <span>View more data</span>
                <ArrowCircleRight
                  style={{ position: 'relative' }}
                  color={max.color}
                />
              </div>
            )}
            </div>

          </div>

          <ArrowProgress arrowColor={'#fff'} rotate={el_perc}>
            <ArrowCircle />
          </ArrowProgress>
          <BackgroundCircle
              thickness={8}
              size={size}
              disableShrink={true}
              variant='determinate'
              value={bcg_value}
              style={{
                rotate: bcg_rotate + 'deg',
                color: 'transparent',
              }}
          />
        </Value>
      </div>
    </Background>
  )
}

export default Percentage
